import { Get_All_Leads_For_Admin_Type, Get_Error } from '../Types';

const intial = {
  AllLeads: [],
  loading: true,
};

const AllLeadsForAdminReducer = (state = intial, action) => {
  switch (action.type) {
    case Get_All_Leads_For_Admin_Type:
      return {
        ...state,
        AllLeads: action.payload,
        loading: false,
      };

    case Get_Error:
      return {
        loading: true,
        AllLeads: action.payload,
      };
    default:
      return state;
  }
};

export default AllLeadsForAdminReducer;
